import React from "react";
import "./style.css";
import FawnButtonMini from "../FawnButtonMini";

function ClientToolbar({ openAccount, openDocs, openBilling, openOther }) {
  return (
    <div>
      <div style={{ color: "black", textAlign: "center" }}>
        <div className="row">
          <div className="col-lg-3 offset-lg-0 col-md-4 offset-md-1 col-10 offset-1">
            <FawnButtonMini buttonText="Account" pf1={(e) => openAccount(e)} />
          </div>
          <div className="col-lg-3 offset-lg-0 col-md-4 offset-md-2 col-10 offset-1">
            <FawnButtonMini buttonText="Service" pf1={(e) => openDocs(e)} />
          </div>
          <div className="col-lg-3 offset-lg-0 col-md-4 offset-md-1 col-10 offset-1">
            <FawnButtonMini buttonText="Billing" pf1={(e) => openBilling(e)} />
          </div>
          <div className="col-lg-3 offset-lg-0 col-md-4 offset-md-2 col-10 offset-1">
            <FawnButtonMini buttonText="Other" pf1={(e) => openOther(e)} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClientToolbar;
